import apiClient from './client';
import type {
  RegisterDeviceRequest,
  RegisterDeviceResponse,
} from '@pp/shared/push/types';

export type {
  DevicePlatform,
  DeviceAudience,
  RegisterDeviceRequest,
  RegisterDeviceResponse,
} from '@pp/shared/push/types';

export const registerDevice = async (
  body: RegisterDeviceRequest,
): Promise<RegisterDeviceResponse> => {
  const response = await apiClient.post<RegisterDeviceResponse>('/devices/register', body);
  return response.data;
};

export const unregisterDevice = async (installationId: string): Promise<void> => {
  await apiClient.delete(`/devices/${installationId}`);
};

export const sendTestPush = async (installationId: string): Promise<void> => {
  await apiClient.post(`/devices/${installationId}/send-test`);
};

/**
 * Field-worker self-service test push. Hits the field-worker endpoint
 * (not /api/devices/{id}/send-test, which is TenantAdmin-only). Server
 * verifies the installation belongs to the caller and fires through
 * Notification Hub at this device specifically.
 */
export const sendTestPushSelf = async (installationId: string): Promise<void> => {
  await apiClient.post(`/field-worker/devices/test-push/${installationId}`);
};
